import { useTranslation } from 'react-i18next';
import DefaultLayout from 'src/components/layouts/DefaultLayout';
import { UsersCRUD } from 'src/components/PropertyManager/Users';

const GuardsPage = () => {
  const { t } = useTranslation('admin', { keyPrefix: 'property.users' });

  return (
    <DefaultLayout title={t('guards')}>
      <UsersCRUD userType={'EPG'} />
    </DefaultLayout>
  );
};

export default GuardsPage;
